// Common symbol / label options for each currency. Fed into the "Custom
// currency formatting" admin picker so a merchant can pick e.g. "kr" or "DKK"
// for Danish Krone instead of typing it. The first entry is the recommended
// default. Merchants can still enter a freeform label via the "Custom…" option.
export const currencySymbols = {
    USD: ["$", "US$", "USD"],
    EUR: ["€", "EUR"],
    GBP: ["£", "GBP"],
    JPY: ["¥", "JPY", "円"],
    CNY: ["¥", "CN¥", "CNY", "元"],
    INR: ["₹", "Rs.", "INR"],
    CAD: ["$", "CA$", "CAD", "C$"],
    AUD: ["$", "AU$", "AUD", "A$"],
    NZD: ["$", "NZ$", "NZD"],
    HKD: ["$", "HK$", "HKD"],
    SGD: ["$", "S$", "SGD"],
    TWD: ["NT$", "TWD"],
    KRW: ["₩", "KRW"],
    // Nordic krone family — all use "kr" symbol but merchants often want the ISO code.
    DKK: ["kr", "DKK", "DK kr"],
    SEK: ["kr", "SEK"],
    NOK: ["kr", "NOK"],
    ISK: ["kr", "ISK"],
    // Swiss
    CHF: ["CHF", "Fr.", "SFr."],
    // Middle East
    AED: ["AED", "DHS", "د.إ"],
    SAR: ["SR", "SAR", "﷼"],
    QAR: ["QR", "QAR"],
    KWD: ["KD", "KWD"],
    BHD: ["BD", "BHD"],
    OMR: ["OR", "OMR", "RO"],
    JOD: ["JD", "JOD"],
    ILS: ["₪", "NIS", "ILS"],
    TRY: ["₺", "TL", "TRY"],
    EGP: ["E£", "EGP", "LE"],
    // South Asia
    PKR: ["Rs.", "PKR"],
    BDT: ["৳", "Tk", "BDT"],
    LKR: ["Rs.", "LKR"],
    NPR: ["Rs.", "NPR"],
    // Southeast Asia
    THB: ["฿", "THB"],
    IDR: ["Rp", "IDR"],
    MYR: ["RM", "MYR"],
    PHP: ["₱", "PHP"],
    VND: ["₫", "VND"],
    // Latin America
    BRL: ["R$", "BRL"],
    MXN: ["$", "MX$", "MXN"],
    ARS: ["$", "AR$", "ARS"],
    CLP: ["$", "CLP"],
    COP: ["$", "COP"],
    PEN: ["S/", "PEN"],
    UYU: ["$", "UYU"],
    // Africa
    ZAR: ["R", "ZAR"],
    NGN: ["₦", "NGN"],
    KES: ["KSh", "KES"],
    GHS: ["GH₵", "GHS"],
    MAD: ["MAD", "DH", "درهم"],
    TND: ["DT", "TND"],
    // Europe (non-EUR)
    PLN: ["zł", "PLN"],
    CZK: ["Kč", "CZK"],
    HUF: ["Ft", "HUF"],
    RON: ["lei", "RON"],
    BGN: ["лв", "BGN"],
    RUB: ["₽", "RUB"],
    UAH: ["₴", "UAH"],
};

export const CUSTOM_LABEL_OPTION = "__custom__";

// Returns [{label: <display>, value: <same>}] for the given currency code,
// with a trailing "Custom label…" entry the caller reveals a text input for.
export function getSymbolOptions(currencyCode) {
    const symbols = currencySymbols[String(currencyCode || "").toUpperCase()] || [];
    return [
        ...symbols.map((s) => ({ label: s, value: s })),
        { label: "Custom label…", value: CUSTOM_LABEL_OPTION },
    ];
}
